import { renderLanding } from './pages/landing.js';
import { renderShow } from './pages/show.js';
import { renderRecipient } from './pages/recipient.js';
import { renderCheckout } from './pages/checkout.js';
import { renderNotFound } from './pages/notFound.js';
import { parseCertPath } from './lib/url.js';

export async function route(root) {
  const { pathname, searchParams } = new URL(window.location.href);
  if (pathname === '/' || pathname === '') {
    return renderLanding(root, { presetName: searchParams.get('name') ?? '' });
  }
  if (pathname.startsWith('/c/')) {
    const parsed = parseCertPath(pathname);
    if (!parsed) return renderNotFound(root);
    setOgImage(ogBase() + `/og/${parsed.id}.png`);
    return renderRecipient(root, parsed);
  }
  if (pathname.startsWith('/checkout/')) {
    const id = pathname.slice('/checkout/'.length);
    if (!/^[a-z0-9]{8}$/.test(id)) return renderNotFound(root);
    return renderCheckout(root, { certId: id });
  }
  if (pathname.startsWith('/show')) {
    return renderShow(root, {});
  }
  return renderNotFound(root);
}

function ogBase() {
  return window.location.hostname.endsWith('.pages.dev')
    ? 'https://gay-certification.victor-053.workers.dev'
    : '';
}

function setOgImage(url) {
  const ensure = (selector, attr, name) => {
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(name === 'og:image' ? 'property' : 'name', name);
      document.head.appendChild(el);
    }
    el.setAttribute(attr, url);
  };
  ensure('meta[property="og:image"]', 'content', 'og:image');
  ensure('meta[name="twitter:image"]', 'content', 'twitter:image');
}
